export const getCategoryTypeFromId = (categoryId) => {
    const map = {
        '6a176c7c-f0c1-499b-a0d9-dcf000563ff8': 'category:commercial',
        '4e552aaa-89ae-49fc-8b4d-a80167cc6016': 'category:compliance',
        '1cc0c23c-b58c-4aa3-ba62-7bc2ac04fddb': 'category:corporate',
        '563d0987-2ffc-45fc-8b29-1dca7bc2cf55': 'category:data',
        '307f45dc-55bf-48e9-9701-563b417939a6': 'category:hr',
        '83c77505-e13d-40a2-a64c-1acf44774c44': 'category:intellectual',
    };
    return map[categoryId];
};
